import { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');

  // Detect if we're on the home page
  const isHome = location.pathname === '/' || location.pathname === '';

  // ===== BUILD ANCHOR HREF =====
  const anchorHref = (hash) => (isHome ? `#${hash}` : `/#${hash}`);

  // ===== HANDLE NAV CLICK =====
  const handleNavClick = (e, hash) => {
    if (!isHome) {
      e.preventDefault();
      navigate(`/#${hash}`);
    }
    // On home, let the global smooth-scroll listener (in Header) handle it
  };

  // ===== NEWSLETTER SUBSCRIPTION =====
  async function send_email() {
    toast.remove();

    if (!email) {
      toast.error('Insira o email');
      return;
    }

    function isValidEmail(value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value.trim());
    }

    if (!isValidEmail(email)) {
      toast.error('email invalido');
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/subscribe/`, {
        email,
      });
      toast.remove();
      setLoading(false);
      setShowConfirmDialog(true);
      setEmail('');
    } catch (error) {
      toast.remove();
      try {
        toast.error('Request failed:' + error.response.data.message);
        console.log(error);
      } catch (e) {
        console.log(e);
        toast.error('Verifique sua conexão e tente novamente!');
      }
      setLoading(false);
    }
  }

  return (
    <>
      {/* ===== SUCCESS MODAL ===== */}
      {showConfirmDialog && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4"
          onClick={() => setShowConfirmDialog(false)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-8 text-center relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={() => setShowConfirmDialog(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition-colors"
              aria-label="Fechar"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="22"
                viewBox="0 -960 960 960"
                width="22"
                fill="currentColor"
              >
                <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
              </svg>
            </button>

            {/* Success icon */}
            <div className="mx-auto w-20 h-20 flex items-center justify-center rounded-full bg-green-100 mb-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
                width="44"
                fill="#16a34a"
              >
                <path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
              </svg>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Subscrito com sucesso!
            </h3>
            <p className="text-gray-500 text-sm mb-6">
              Obrigado por se inscrever. Em breve receberá as nossas novidades.
            </p>

            <button
              onClick={() => setShowConfirmDialog(false)}
              className="w-full bg-blue-700 hover:bg-blue-800 text-white py-3 rounded-xl font-bold transition-colors"
            >
              Fechar
            </button>
          </div>
        </div>
      )}

      <footer className="bg-gray-900 text-white pt-20 pb-10 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
            <div className="space-y-6">
              <a
                className="flex items-center gap-2"
                href={isHome ? '#home' : '/'}
                onClick={(e) => {
                  if (!isHome) {
                    e.preventDefault();
                    navigate('/');
                  } else {
                    e.preventDefault();
                    const target = document.querySelector('#home');
                    if (target) target.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                <span className="text-2xl font-black text-blue-400 tracking-tighter">
                  VLMS
                </span>
              </a>
              <p className="text-gray-400 leading-relaxed">
                Sistema Inteligente de Gestão de Microcrédito. Otimize as
                operações da sua instituição de forma eficiente, segura e
                acessível.
              </p>
              <div className="flex gap-4">
                <a
                  href="#"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6 border-l-4 border-blue-600 pl-4">
                Navegação
              </h4>
              <ul className="space-y-4 text-gray-400">
                <li>
                  <a
                    className="hover:text-blue-400 transition-colors"
                    href={anchorHref('home')}
                    onClick={(e) => handleNavClick(e, 'home')}
                  >
                    Início
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-blue-400 transition-colors"
                    href={anchorHref('features')}
                    onClick={(e) => handleNavClick(e, 'features')}
                  >
                    Recursos
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-blue-400 transition-colors"
                    href={anchorHref('tutorials')}
                    onClick={(e) => handleNavClick(e, 'tutorials')}
                  >
                    Na Prática
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-blue-400 transition-colors"
                    href={anchorHref('plans')}
                    onClick={(e) => handleNavClick(e, 'plans')}
                  >
                    Planos
                  </a>
                </li>
                <li>
                  <a
                    className="hover:text-blue-400 transition-colors"
                    href={anchorHref('faq')}
                    onClick={(e) => handleNavClick(e, 'faq')}
                  >
                    FAQ
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6 border-l-4 border-blue-600 pl-4">
                Contactos
              </h4>
              <ul className="space-y-4 text-gray-400">
                <li className="flex items-start gap-3">
                  <i className="fas fa-map-marker-alt text-blue-500 mt-1"></i>{' '}
                  Maputo, Moçambique
                </li>
                <li className="flex items-center gap-3">
                  <i className="fas fa-envelope text-blue-500"></i>{' '}
                  info@vlms.co.mz
                </li>
                <li className="flex items-center gap-3">
                  <i className="fas fa-phone text-blue-500"></i> +258 86 972 3000
                </li> 
              </ul>

              {/* ===== INFORMAÇÃO (Terms & Privacy) ===== */}
              <h4 className="text-lg font-bold mb-6 mt-10 border-l-4 border-blue-600 pl-4">
                Informação
              </h4>
              <ul className="space-y-4 text-gray-400">
                <li>
                  <Link
                    to="/privacy-politics"
                    className="hover:text-blue-400 transition-colors"
                  >
                    Políticas de privacidade
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms"
                    className="hover:text-blue-400 transition-colors"
                  >
                    Termos e condições
                  </Link>
                </li>
              </ul>
            </div>

            <div className={loading ? 'loading' : ''}>
              <h4 className="text-lg font-bold mb-6 border-l-4 border-blue-600 pl-4">
                Newsletter
              </h4>
              <p className="text-sm text-gray-400 mb-4">
                Receba novidades sobre gestão de microcrédito.
              </p>
              <form
                className="space-y-3"
                onSubmit={(e) => {
                  e.preventDefault();
                  send_email();
                }}
              >
                <input
                  placeholder="E-mail"
                  className="w-full bg-gray-800 border-none rounded-xl py-3 px-4 focus:ring-2 focus:ring-blue-600 outline-none text-white placeholder-gray-500"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-blue-700 hover:bg-blue-800 py-3 rounded-xl font-bold transition-colors disabled:opacity-60"
                >
                  {loading ? 'A inscrever...' : 'Inscrever'}
                </button>
              </form>
            </div>
          </div>

          <div className="pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
            <p>© 2026 VLMS Microcrédito. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;